import { Color } from '@zen/Styleguide';

import type { IconCircleSize } from './types';

const colorValues: string[] = Object.values(Color);

export const isColorBasic = (color: string): boolean => {
  return colorValues.includes(color);
};

export const variantClassNames: Record<IconCircleSize, string> = {
  compact: 'h-4 w-4',
  default: 'h-6 w-6'
};
